/**
 * Nav items for the user profile dropdown
 */
export function profileMenuItems(I18n) {
  return [
    { label: I18n.t('nav.profile'), to: { name: 'userProfile' } },
    { label: I18n.t('general.logout'), key: 'logout' },
  ];
}

/**
 * Nav items for adding an operation
 */
export function addOperationMenuItems(I18n) {
  const items = [
    { type: 'plants', routeName: 'newOperation' },
    { type: 'shafts', routeName: 'newShaft' },
    { type: 'shafts_v2', routeName: 'newShaftV2' },
    { type: 'ships', routeName: 'newShip' },
    { type: 'equipment', routeName: 'newEquipment' },
  ];

  return items.map((item) => ({
    label: `${I18n.t('general.new')}
            ${I18n.t(`activerecord.models.${item.type}.one`)}`,
    to: { name: item.routeName },
  }));
}

/**
 * Nav log out
 */
export async function logOut(ajax) {
  await ajax('/users/sign_out', { method: 'DELETE' });
  window.location.href = '/users/sign_in';
}
